<h2 mat-dialog-title class="dialog-header">
  <span>Literal</span>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="form-grid">
    <mat-form-field appearance="outline" class="readonly-field">
      <mat-label>ID</mat-label>
      <input matInput type="number" [(ngModel)]="literal.id" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Origin Text</mat-label>
      <input matInput [(ngModel)]="literal.originText">
    </mat-form-field>

    <mat-card>
      <div class="admin-page-header">
        <h3 class="admin-page-title">Translations</h3>
        <div class="dialog-actions-wrap">
          <mat-form-field appearance="outline">
            <mat-label>Lang</mat-label>
            <mat-select [(ngModel)]="langToAdd">
              <mat-option *ngFor="let lang of getLangs()" [value]="lang.landId">{{ lang.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-stroked-button color="primary" (click)="addTranslation()">Anadir</button>
        </div>
      </div>

      <div class="form-grid">
        <mat-card *ngFor="let translation of literal.translations">
          <div class="admin-page-header">
            <strong>{{ translation.lang.name }}</strong>
            <button mat-button color="warn" (click)="deleteTranslation(translation)">Eliminar idioma</button>
          </div>
          <mat-form-field appearance="outline" class="full-span">
            <mat-label>Translation</mat-label>
            <textarea matInput rows="6" [(ngModel)]="translation.translation"></textarea>
          </mat-form-field>
        </mat-card>
      </div>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <div class="dialog-actions-spread">
    <button mat-stroked-button color="warn" (click)="deleteLiteral()">Eliminar</button>
    <button mat-raised-button color="primary" (click)="confirm()">Guardar</button>
  </div>
</mat-dialog-actions>
